export default {
    actions: {
        getPages(ctx, data) {
            axios
                .get(data.path + `/pagesForFront`)
                .then(response => {
                    const pages = response.data;

                    ctx.commit('updatePages', pages)
                })
        },
        getPageBySlug(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(data.path + `/pages/slug/${data.slug}`)
                    .then(response => {
                        const page = response.data;
                        ctx.commit('updatePage', page)
                    }).catch(e => {
                    reject(e);
                });
            });
        },
    },
    mutations: {
        updatePages(state, pages) {
            state.pages = pages
        },
        updatePage(state, page) {
            state.page = page
        },
    },
    state: {
        pages: [],
        page: null,
    },
    getters: {
        allPages(state) {
            return state.pages
        },
        /**
         * @return {null}
         */
        Page(state) {
            return state.page
        },
    }
}
